var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gas"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2111 2C15.4189 2 15.5874 2.16845 15.5874 2.37624C15.5874 2.58403 15.4189 2.75248 15.2111 2.75248L14.4781 2.75248V5.36634H15.2309C16.6531 5.36634 17.806 6.51887 17.806 7.94059V17.0099C17.806 18.2835 16.8808 19.3411 15.6656 19.5476C15.6663 19.5597 15.6667 19.5719 15.6667 19.5842V21.3663C15.6667 21.7163 15.3829 22 15.0328 22H8.77323C8.42314 22 8.13935 21.7163 8.13935 21.3663V19.5842C8.13935 19.5719 8.13969 19.5597 8.14038 19.5476C6.9252 19.3411 6 18.2835 6 17.0099V7.94059C6 6.51887 7.15293 5.36634 8.57514 5.36634H9.44672V2.75248H8.59495C8.38709 2.75248 8.21858 2.58403 8.21858 2.37624C8.21858 2.16845 8.38709 2 8.59495 2L15.2111 2ZM13.7254 2.75248V5.36634H12.4973V4.63366C12.4973 4.33838 12.2578 4.09901 11.9624 4.09901C11.6671 4.09901 11.4276 4.33838 11.4276 4.63366V5.36634H10.1995V2.75248H13.7254ZM8.89208 19.5842V21.2475H14.9139V19.5842H8.89208ZM6.75672 7.90099C6.81781 6.99401 7.57312 6.27723 8.4959 6.27723H15.3101C16.2329 6.27723 16.9882 6.99401 17.0493 7.90099H6.75672ZM6.75273 8.65347V16.2574H17.0533V8.65347H6.75273ZM8.4959 18.6733C7.55973 18.6733 6.79592 17.9355 6.7545 17.0099H17.0515C17.0101 17.9355 16.2463 18.6733 15.3101 18.6733H8.4959Z",
    fill: "#183883"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/Gas.4e14ce84f4c45efb464e2b9acdeac366.svg";
export { ForwardRef as ReactComponent };